import { MolsonRadioButton } from '@components/reusable'
import type { SxProps } from '@mui/material'
import { type molsonTheme } from '@theme'
import { molsonUseTheme } from '@theme/customMuiExports'

type ChipProps = {
  checked: boolean
  customSx?: SxProps<typeof molsonTheme>
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  text: string
}

export const CustomCheckedChip = ({
  checked,
  customSx,
  onChange,
  text
}: ChipProps) => {
  const theme = molsonUseTheme()

  const defaultSx = {
    '& *': {
      fontSize: '20px !important'
    },
    '& span': {
      color: checked
        ? theme.palette.primary.darkest
        : theme.palette.secondary[700],
      fontSize: '14px !important',
      fontWeight: 600
    },
    alignItems: 'center',
    bgcolor: checked ? theme.palette.primary.lightest : 'transparent',
    border: `1px solid ${
      checked ? theme.palette.secondary[0] : theme.palette.secondary[400]
    }`,
    borderRadius: 100,
    display: 'flex',
    padding: 0,
    paddingLeft: 1,
    paddingRight: 2,
    width: 'fit-content',
    ...customSx
  }

  return (
    <MolsonRadioButton
      formControlLabelProps={{
        checked: checked,
        label: text,
        sx: defaultSx
      }}
      radioBtnProps={{ onChange: onChange }}
    />
  )
}
